import styled from "styled-components";
import { PrimaryButton } from "../../../components/button";
import { Flex } from "../../../components/layout";
import { ButtonWrapper } from "../base";

const Container = styled(Flex)`
  justify-content: flex-end;
`;

export const Buttons: React.FunctionComponent<{
  setEditing: (b: boolean) => void;
  editing?: boolean;
}> = ({ setEditing, editing = false }) => {
  return (
    <Container>
      <ButtonWrapper>
        <PrimaryButton
          disabled={editing}
          variant="contained"
          onClick={() => setEditing(true)}
        >
          Edit
        </PrimaryButton>
      </ButtonWrapper>
    </Container>
  );
};
